import { render } from "./PickedUpReservation.vue?vue&type=template&id=2473d863&scoped=true&ts=true"
import script from "./PickedUpReservation.vue?vue&type=script&lang=ts"
export * from "./PickedUpReservation.vue?vue&type=script&lang=ts"

import "./PickedUpReservation.vue?vue&type=style&index=0&id=2473d863&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2473d863"]])

export default __exports__